import React, { PropTypes } from 'react';

import './style.scss';

const RepliesListContentSticky = (props) => (
  <div className="RepliesListContentSticky">
    {props.children}
  </div>
);

RepliesListContentSticky.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.node)
  ])
};

export default RepliesListContentSticky;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/RepliesList/RepliesListContentSticky/index.js
 **/